import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Slick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MagicSliderDots from 'react-magic-slider-dots';
import 'react-magic-slider-dots/dist/magic-dots.css';

import CardImage from '../CardImage';
import { wrapEventHandler } from '../../../utils/handlers';

import styles from './styles/styles.module.scss';

import CarouselArrowNext from '../../../../assets/images/icons/carouselArrowNext.svg';
import CarouselArrowPrev from '../../../../assets/images/icons/carouselArrowPrev.svg';

const ArrowFn = (key, bg) => {
  return ({ className, style, onClick }) => {
    return (
      <button
        aria-label={key}
        className={`${className} ${styles.button} ${styles[key]} lazyload`}
        data-bg={bg}
        onClick={onClick}
        style={style}
        title={key}
        type="button"
      />
    );
  };
};

const NextArrow = ArrowFn('next', CarouselArrowNext);
const PrevArrow = ArrowFn('previous', CarouselArrowPrev);

const appendDots = dots => {
  return <MagicSliderDots dots={dots} numDotsToShow={4} dotWidth={20} />;
};

class CardImageCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false
    };
  }

  handleBeforeChange = (oldIndex, newIndex) => {
    if (this.props.handleBeforeChange) {
      this.props.handleBeforeChange(oldIndex, newIndex);
    }
    this.setState({ dragging: true });
  };

  handleAfterChange = index => {
    if (this.props.handleAfterChange) {
      this.props.handleAfterChange(index);
    }
    this.setState({ dragging: false });
  };

  handleCardClick = () => {
    // Prevent propagation of click to inner elements when dragging slick carousel
    if (this.state.dragging) {
      return;
    }
    if (this.props.handleCardClick) {
      this.props.handleCardClick();
    }
  };

  render() {
    const { className, classNameImage, lowerButtons, photoUrls, slickSettings, title } = this.props;

    const settings = {
      accessibility: true,
      afterChange: this.handleAfterChange,
      appendDots,
      beforeChange: this.handleBeforeChange,
      className: `${className} ${styles.slickCarousel} ${lowerButtons ? styles.lowerButtons : ''}`,
      dots: true,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'progressive',
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 300,
      swipeToSlide: true
    };
    if (slickSettings) {
      Object.assign(settings, slickSettings);
    }

    return (
      <Slick {...settings}>
        {photoUrls.map(photoUrl => (
          <CardImage
            className={classNameImage}
            key={photoUrl}
            lazyload={false}
            onClick={wrapEventHandler(this.handleCardClick)}
            url={photoUrl}
            title={title}
          />
        ))}
      </Slick>
    );
  }
}

CardImageCarousel.defaultProps = {
  className: '',
  classNameImage: '',
  handleCardClick: null,
  lowerButtons: false,
  photoUrls: [],
  slickSettings: {},
  trail: {}
};

CardImageCarousel.propTypes = {
  className: PropTypes.string,
  classNameImage: PropTypes.string,
  handleCardClick: PropTypes.func,
  lowerButtons: PropTypes.bool,
  photoUrls: PropTypes.arrayOf(PropTypes.string),
  slickSettings: PropTypes.object,
  trail: PropTypes.object
};

export default CardImageCarousel;
